import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function IncludesSection() {
  const scrollToPrice = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const includedItems = ['Guía para entender el SIBO', 'Plan completo de 21 días', 'Menú semanal (4 comidas por día)', 'Lista de compras para el súper', 'Recetario con 50 recetas', 'Sustitución de alimentos', 'Panificados y masa madre', 'Movimiento digestivo'];
  return <section className="py-12 sm:py-16 lg:py-20 bg-brand-bg-beige overflow-hidden" data-id="element-85">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <motion.h2 className="text-3xl sm:text-4xl font-playfair font-bold text-brand-text-dark mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-88">
            Todo lo que necesitás para{' '}
            <span className="italic text-brand-green" data-id="element-89">empezar hoy</span>
          </motion.h2>
          <div className="w-24 h-1 bg-brand-green mx-auto rounded-full" data-id="element-90"></div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-91">
          {/* Mockup Image */}
          <motion.div className="flex-1 w-full" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-92">
            <div className="relative" data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/fwg8piCLsLpndcN7tjXU5N/mock_up_-_que_incluye.png" alt="Pack de ebooks Libre de SIBO" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-94" />
            </div>
          </motion.div>

          {/* List Content */}
          <motion.div className="flex-1 w-full max-w-lg lg:max-w-none" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-95">
            <div className="bg-white p-8 sm:p-10 rounded-3xl shadow-xl border border-brand-bg-cream" data-id="element-96">
              <h3 className="text-2xl font-playfair font-bold text-brand-text-dark mb-8 text-center lg:text-left" data-id="element-97">
                ¿Qué incluye el plan?
              </h3>

              <ul className="space-y-4 mb-10" data-id="element-98">
                {includedItems.map((item, index) => <motion.li key={index} className="flex items-start gap-3" initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} data-id="element-99">
                    <div className="mt-1 bg-brand-green/10 p-1 rounded-full flex-shrink-0" data-id="element-100">
                      <Check className="w-4 h-4 text-brand-green" data-id="element-101" />
                    </div>
                    <span className="text-brand-text-dark font-medium" data-id="element-102">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>

              <button onClick={scrollToPrice} className="w-full bg-brand-green hover:bg-brand-green-light text-white font-poppins font-bold text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-103">
                QUIERO EL PLAN COMPLETO
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}